import React from 'react';

import { ReactComponent as Icon } from '../../../../assets/icons/share.svg';

export const ShareIcon = (props: any) => {
    return <Icon {...props} alt="share" />;
};
